import { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { numberWithSpaces } from "../../../utilities/formaters";

export default class CreditDataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      openDialog: false,
      creditId: "",
      filters: {},
      selected: {},
      allSelected: false,
      openSellAllDialog: false,
    };
  }

  openSellAll = () => {
    this.setState({ openSellAllDialog: true });
  };

  openDialog = (item) => {
    this.setState({ openDialog: true, creditId: item.Id });
  };

  closeDialog = () => {
    this.setState({
      openDialog: false,
      submitted: false,
      openSellAllDialog: false,
    });
  };

  sendSellOrder = () => {
    this.setState({ submitted: true });
    this.props.sendSellOrder(
      this.props.fee,
      this.state.creditId,
      this.props.depotId,
    );
  };

  sendSellOrderAll = () => {
    let selected = Object.keys(this.state.selected);
    this.setState({ submitted: true });
    for (let i = 0; i < selected.length; i++) {
      let id = selected[i];

      this.props.sendSellOrder(this.props.fee, id, this.props.depotId);
    }
  };

  changeFilter = (name, value) => {
    this.setState({
      filter: Object.assign(this.state.filters, { [name]: value }),
    });
  };

  updateCheck = (id, event) => {
    let value = event.target.value;
    let selected = this.state.selected;
    let allSelected = this.state.allSelected;
    if (value) selected[id] = value;
    else delete selected[id];

    if (!value) allSelected = false;

    this.setState({ selected, allSelected });
  };

  selectAll = () => {
    let selected = {};
    this.props.dataRow.map((row) => {
      selected[row.Id] = !this.state.allSelected;
    });
    this.setState({ selected, allSelected: !this.state.allSelected });
  };

  doFilters = (data) => {
    return data.filter((item) => {
      let filters = Object.keys(this.state.filters);

      for (let i = 0; i < filters.length; i++) {
        let filterName = filters[i];
        let filter = this.state.filters[filterName];

        if (filter.value === "") continue;

        let valueToCheck = filter.valueKey
          ? item[filterName][filter.valueKey]
          : item[filterName];

        if (filter.type == FILTER_TYPES.equal) {
          return valueToCheck == filter.value;
        }

        if (filter.type == FILTER_TYPES.more) {
          return valueToCheck > filter.value;
        }

        if (filter.type == FILTER_TYPES.less) {
          return valueToCheck < filter.value;
        }
      }

      return true;
    });
  };

  render() {
    const actions = [
      <Button
        key="1"
        variant="outlined"
        onClick={this.closeDialog}
        style={{ float: "left" }}
      >
        Close
      </Button>,
      <Button
        key="2"
        variant="contained"
        color="primary"
        keyboardFocused={false}
        onClick={this.state.submitted ? this.closeDialog : this.sendSellOrder}
      >
        {this.state.submitted ? "Close" : "Send Sell Order"}
      </Button>,
    ];

    const actionsSellAll = [
      <Button
        key="1"
        variant="outlined"
        onClick={this.closeDialog}
        style={{ float: "left" }}
      >
        Close
      </Button>,
      <Button
        key="2"
        variant="contained"
        color="primary"
        keyboardFocused={false}
        onClick={
          this.state.submitted ? this.closeDialog : this.sendSellOrderAll
        }
      >
        {this.state.submitted ? "Close" : "Send Sell Order"}
      </Button>,
    ];

    let { dataRow } = this.props;
    dataRow = this.doFilters(dataRow);

    return (
      <div>
        <Dialog
          modal={false}
          open={this.state.openDialog}
          onClose={this.closeDialog}
        >
          <DialogTitle>Confirm Sell order</DialogTitle>
          <DialogContent>
            Are you sure you want to sell creditId: {this.state.creditId} with
            fee {this.props.fee} %
            <FeedbackMsg
              {...this.props}
              submitted={this.state.submitted}
              creditIds={[this.state.creditId]}
            />
            {this.props.currentUser.saleorderComplete}
          </DialogContent>
          <DialogActions>{actions}</DialogActions>
        </Dialog>

        <Dialog
          modal={false}
          open={this.state.openSellAllDialog}
          onClose={this.closeDialog}
        >
          <DialogTitle>Confirm Sell All Selected</DialogTitle>
          <DialogContent>
            Are you sure you want to sell all{" "}
            {Object.keys(this.state.selected).length} Credits.
            <FeedbackMsg
              {...this.props}
              submitted={this.state.submitted}
              creditIds={Object.keys(this.state.selected)}
            />
            {this.props.currentUser.saleorderComplete}
          </DialogContent>
          <DialogActions>{actionsSellAll}</DialogActions>
        </Dialog>
        <div style={{ margin: "20px 0px" }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={this.state.allSelected}
                onCheck={this.selectAll}
                style={{
                  display: "inline-block",
                  marginRight: "20px",
                  width: "240px",
                }}
              />
            }
            label="Select all"
          />
          <Button
            variant="contained"
            color="primary"
            style={{ verticalAlign: "bottom" }}
            keyboardFocused={false}
            onClick={this.openSellAll}
          />
        </div>
        <table className="small-info-table">
          <thead>
            <tr>
              <td style={{ width: "50px" }}>
                <NoFilterHeader name="" />
              </td>
              <td>
                <FilterHeader
                  name="Share Value"
                  filterName="ShareValue"
                  filter={this.state.filters["ShareValue"]}
                  changeFilter={this.changeFilter}
                  valueKey="Amount"
                />
              </td>
              <td>
                <FilterHeader
                  name="Originator"
                  filterName="Originator"
                  filter={this.state.filters["Originator"]}
                  changeFilter={this.changeFilter}
                />
              </td>
              <td>
                <FilterHeader
                  name="Remaining"
                  filterName="Remaining"
                  filter={this.state.filters["Remaining"]}
                  changeFilter={this.changeFilter}
                  valueKey="Value"
                />
              </td>
              <td>
                <FilterHeader
                  name="Share"
                  filterName="Share"
                  filter={this.state.filters["Share"]}
                  changeFilter={this.changeFilter}
                  valueKey="Value"
                />
              </td>
              <td>
                <NoFilterHeader name="Sell" />
              </td>
            </tr>
          </thead>
          <tbody>
            {dataRow.map((item, index) => (
              // eslint-disable-next-line react/jsx-key
              <Row
                item={item}
                index={index}
                selected={this.state.selected}
                updateCheck={this.updateCheck}
                openDialog={this.openDialog}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const Row = ({ item, index, openDialog, selected, updateCheck }) => {
  let amount = item.ShareValue
    ? item.ShareValue.Amount
    : item.LoanAmount.Amount;
  return (
    <tr key={"row-sell-order-" + index}>
      <td style={{ width: "50px" }}>
        <Checkbox
          checked={!!selected[item.Id]}
          onCheck={updateCheck.bind(this, item.Id)}
        />
      </td>
      <td>{numberWithSpaces(amount)}</td>
      <td>{item.Originator}</td>
      <td>
        {numberWithSpaces(Math.round(item.Remaining.Value * 10000) / 100)}%
      </td>
      <td>{numberWithSpaces(Math.round(item.Share.Value * 10000) / 100)}%</td>
      <td>
        <Button
          variant="contained"
          color="primary"
          keyboardFocused={false}
          onClick={openDialog.bind(this, item)}
        >
          Send Sell Order
        </Button>
      </td>
    </tr>
  );
};

const FeedbackMsg = ({ currentUser, submitted, creditIds }) => {
  return (
    <div>
      {creditIds.map((id) => {
        if (!submitted || !currentUser.sellOrder[id]) return <div key={id} />;
        if (currentUser.sellOrder[id].sendingSellOrder)
          return (
            <div key={id}>
              Credit Id {id} in progres <CircularProgress />
            </div>
          );

        if (currentUser.sellOrder[id].sellOrderError)
          return (
            <div key={id} style={{ color: "red" }}>
              Order error for Credit Id {id}: &apos;
              {currentUser.sellOrder[id].sellOrderError}&apos;
            </div>
          );
        if (currentUser.sellOrder[id].saleorderComplete)
          return (
            <div key={id} style={{ color: "green" }}>
              Order Send sucessfuly for Credit Id {id}
            </div>
          );
      })}
    </div>
  );
};

const FILTER_TYPES = {
  more: "more",
  less: "less",
  equal: "equal",
};

const FILTER_TYPES_DISPLAY = {
  [FILTER_TYPES.equal]: "=",
  [FILTER_TYPES.less]: "<",
  [FILTER_TYPES.more]: ">",
};

class FilterHeader extends Component {
  componentDidMount() {
    this.initFilter();
  }

  render() {
    let { name, filter } = this.props;
    if (!filter) return <div />;

    return (
      <div style={{ position: "relative" }}>
        <div className="header-table">{name}</div>
        <span
          className="header-table-filter-type"
          onClick={this.changeFilterType}
        >
          {FILTER_TYPES_DISPLAY[filter.type]}
        </span>
        <input type="text" onChange={this.changeFilterValue} />
      </div>
    );
  }

  initFilter = () => {
    this.changeFilter({
      value: "",
      type: FILTER_TYPES.equal,
      valueKey: this.props.valueKey,
    });
  };

  changeFilterValue = (event) => {
    let filter = this.props.filter;
    filter.value = event.target.value;
    this.props.changeFilter(this.props.filterName, filter);
  };

  changeFilterType = () => {
    let filter = this.props.filter;
    if (filter.type == FILTER_TYPES.equal) filter.type = FILTER_TYPES.more;
    else if (filter.type == FILTER_TYPES.more) filter.type = FILTER_TYPES.less;
    else if (filter.type == FILTER_TYPES.less) filter.type = FILTER_TYPES.equal;

    this.props.changeFilter(this.props.filterName, filter);
  };

  changeFilter = (filter) => {
    this.props.changeFilter(this.props.filterName, filter);
  };
}

class NoFilterHeader extends Component {
  render() {
    let { name } = this.props;

    return (
      <div style={{ position: "relative" }}>
        <div className="header-table">{name}&nbsp;</div>

        <input type="text" disabled />
      </div>
    );
  }
}
